<template lang="pug">
  .card
    .card-header(v-if="title") {{ title }}
    .card-body
      slot
</template>

<script>
export default {
  name: 'card',

  props: ['title']
}
</script>
